export default __webpack_public_path__ + "static/media/play.dbc0b0a1.svg";